export default __webpack_public_path__ + "static/media/kitchen3-afterE-1440w.ec05dcee.png";